import React from "react";
import {
  Box,
  Card,
  CardBody,
  HStack,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { formatInteger, formatNumber } from "../networkReportFormatters";
import FactorClassificationBadge from "./FactorClassificationBadge";

const DetailRow = ({ label, children }) => (
  <HStack justify="space-between" align="start" spacing={4}>
    <Text color="gray.500" fontSize="sm">{label}</Text>
    <Box textAlign="right" fontSize="sm">{children}</Box>
  </HStack>
);

const FactorRankingCardList = ({ factors = [] }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const mutedColor = useColorModeValue("gray.600", "gray.400");

  return (
    <VStack align="stretch" spacing={3}>
      {factors.map((factor) => (
        <Card key={factor.id} bg={cardBg} borderWidth="1px" borderColor={borderColor}>
          <CardBody>
            <VStack align="stretch" spacing={3}>
              <Box>
                <Text fontWeight="semibold">{factor.name}</Text>
                <Text fontSize="sm" color={mutedColor}>
                  Factor category: {factor.areaLabel}
                </Text>
              </Box>
              <DetailRow label="Stability">{formatNumber(factor.stabilityIndex)}</DetailRow>
              <DetailRow label="Schools included">{formatInteger(factor.organizationsIncluded)}</DetailRow>
              <DetailRow label="Respondents">{formatInteger(factor.respondents)}</DetailRow>
              <DetailRow label="Classification">
                <FactorClassificationBadge classification={factor.classification} />
              </DetailRow>
            </VStack>
          </CardBody>
        </Card>
      ))}
    </VStack>
  );
};

export default FactorRankingCardList;
